import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09cb1b31")

_pushScopeId("data-v-09cb1b31")
const _hoisted_1 = {
  class: "pa-4",
  style: {"height":"100vh","display":"flex","flex-direction":"column"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "pa-4" }, [
  /*#__PURE__*/_createTextVNode(" 实时监测"),
  /*#__PURE__*/_createVNode("span", {
    class: "unit",
    style: {"font-size":".7em","opacity":".86"}
  }, "（千克/秒）")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_my_card, { style: {"display":"flex","flex-direction":"column","flex":"1"} }, {
      header: _withId(() => [
        _hoisted_2
      ]),
      default: _withId(() => [
        _createVNode(_component_my_card_body, { style: {"height":"100%","position":"relative"} }, {
          default: _withId(() => [
            _createVNode("div", {
              style: {"height":"100%","width":"100%"},
              ref: $setup.setRef
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})